//I've moved the initializer into the dom-ready to allow some code to run before...
document.addEventListener("DOMContentLoaded", (fn) => {
  Alpine.start();
});
